import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  report: localStorage.getItem('report')
    ? JSON.parse(localStorage.getItem('report'))
    : null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setReports: (state, action) => {
      state.report = action.payload;
      localStorage.setItem('report', JSON.stringify(action.payload));
    },
  },
});

export const {setReports } = reportSlice.actions;

export default reportSlice.reducer;
